import { landingApiRequest } from '@/lib/landing-api'
import { ApiClientError } from '@/lib/api/client'
import { parseMascotConfig, type MascotConfig } from './mascot-catalog'

export async function saveDonorMascot(
  mascot: MascotConfig,
  campaignId?: number
): Promise<MascotConfig> {
  const response = await landingApiRequest<{ mascot: unknown }>(
    campaignId ? `/api/donor/campaigns/${campaignId}/mascot` : '/api/donor/mascot',
    {
      method: 'PUT',
      body: JSON.stringify({ mascot }),
    }
  )
  const saved = parseMascotConfig(response.mascot)
  if (!saved)
    throw new ApiClientError(
      'Não foi possível confirmar seu mascote. Tente novamente.',
      0
    )
  return saved
}
